import mnFooter from './index.vue'

const FooterMN = {
  install: function (Vue) {
    Vue.component('FooterMN', mnFooter)
  }
}
export default FooterMN



// WEBPACK FOOTER //
// ./src/components/mnFooter/index.js